export default "__VITE_ASSET__CIFGb9lD__"